import { Component } from '@angular/core';

@Component({
  selector: 'app-pontuacao',
  templateUrl: './pontuacao.component.html',
  styleUrls: ['./pontuacao.component.css']
})
export class PontuacaoComponent {
}



// WEBPACK FOOTER //
// ./src/app/publico/sorteios/pontuacao/pontuacao.component.ts